var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},_vm._l((_vm.projects),function(project){return _c('div',{key:project.title,staticClass:"row"},[_c('pub-card',_vm._b({},'pub-card',project,false))],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }